import { /*qS, */qSA } from 'dompack/extra/qsa';

export function fixupScopeTRs(node)
{
  console.log('fixupScopeTRs',node);
  for(let tr of qSA(node, 'tr'))
  {
    let scoperow = !!tr.querySelector('th[scope=row]');
    tr.classList[scoperow?'add':'remove']('wh-rtd--hasrowheader');

    let scopecol = !!tr.querySelector('th[scope=col]');
    tr.classList[scopecol?'add':'remove']('wh-rtd--hascolheader');
  }
}



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/components/richeditor/internal/support.es